import { atom } from 'recoil'

export const isOpenSideMenu = atom({
	key: 'isOpenSideMenu',
	default: false,
})
